export default {
    MailComposeReply: {
        datapoint: {
            name: 'MailComposeReply',
            options: { isQos: true },
            customData: function (referenceItemId, useFullCompose, conversationId, body, actionSource) { return [actionSource, useFullCompose]; },
        },
    },
    MailComposeReplyAll: {
        datapoint: {
            name: 'MailComposeReplyAll',
            options: { isQos: true },
            customData: function (referenceItemId, useFullCompose, conversationId, body, actionSource) { return [actionSource, useFullCompose]; },
        },
    },
    MailComposeForward: {
        datapoint: {
            name: 'MailComposeForward',
            customData: function (referenceItemIdStr, actionSource) { return [actionSource]; },
        },
    },
    MailComposeSend: {
        datapoint: {
            name: 'MailComposeSend',
            customData: function (showErrorToUser, isAsyncSend, messageText) { return [showErrorToUser, isAsyncSend, null /* TODO: 24239 */]; },
        },
    },
    MailComposeSendAsync: { datapoint: { name: 'MailComposeSendAsync' } },
    MailComposeSendE2E: {
        datapoint: {
            name: 'MailComposeSendE2E',
            options: { isQos: true, doNotSample: true },
            customData: function (viewState) { return ({
                composeTraceId: viewState.logTraceId,
            }); },
        },
    },
    MailComposeSave: { datapoint: { name: 'MailComposeSave' } },
    MailComposeUpConvert: { datapoint: { name: 'MailComposeUpConvert' } },
    ComposeCommandDiscardCompose: {
        datapoint: {
            name: 'ComposeCommandDiscardCompose',
            customData: function (viewState) { return ({
                composeTraceId: viewState.logTraceId,
            }); },
        },
    },
    ComposeCommandShowFrom: {
        datapoint: {
            name: 'ComposeCommandShowFrom',
        },
    },
    ComposeCommandSetImportance: {
        datapoint: {
            name: 'ComposeCommmandSetImportance',
            customData: function (viewState, importance) { return [importance]; },
        },
    },
    SmartReplySendMessage: {
        datapoint: {
            name: 'SmartReplySendMessage',
            customData: function (eid) { return [eid]; },
        },
    },
    SmartReplySaveMessage: {
        datapoint: {
            name: 'SmartReplySaveMessage',
            customData: function (eid) { return [eid]; },
        },
    },
    SmartReplyDiscardMessage: {
        datapoint: {
            name: 'SmartReplyDiscardMessage',
            customData: function (eid) { return [eid]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map